import React from 'react';
import { ModalsProvider } from './ModalsContext';
import { NavProvider } from './NavContext';
import { StickyBarProvider } from './StickyBarContext';
import { SolutionBuilderProvider } from './SolutionBuilderContext';
import { RichFilteringProvider } from './RichFilteringContext';

/**
 * Uses a Context.Consumer as a HOC to allow its use in lifecycle methods.
 * Another advantage is that it's easier to access the values and methods from
 * any component method.
 *
 * Idea taken from https://github.com/facebook/react/issues/12397#issuecomment-375501574
 *
 * @param {React.Consumer} Consumer
 * @param {string} [propName] How the consumer value will be accessed via props. If not set,
 * then context value will be accessed via props.contextValue
 * @returns {Function} Function that receives the object to decorate.
 */
export const withConsumer = (
  Consumer,
  propName = 'contextValue',
) => Component =>
  React.forwardRef((props, ref) => (
    <Consumer>
      {consumerValue => (
        <Component {...props} ref={ref} {...{ [propName]: consumerValue }} />
      )}
    </Consumer>
  ));

const Providers = props => (
  <ModalsProvider>
    <StickyBarProvider>
      <SolutionBuilderProvider>
        <NavProvider>
          <RichFilteringProvider>{props.children}</RichFilteringProvider>
        </NavProvider>
      </SolutionBuilderProvider>
    </StickyBarProvider>
  </ModalsProvider>
);

export default Providers;
